class UserUtil {
  static IsUserPasswordStrong(password: string) {
    var regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
    if (password.match(regex)) {
      return true;
    } else {
      return false;
    }
  }

  static IsValidEmailFormat = (email: string) => {
    const emailRex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const result = email ? email.match(emailRex) : false;
    if (result) return true;
    else return false;
  };
}

export default UserUtil;
